import React, { useEffect } from "react";
import "../../components/login/bootstraplogin.css";
import { findIsHostShipAi } from "../../config/utils";
import { useSelector } from "react-redux";
import { verifySignupToken } from "../../store/actions/userOnboarding";
import { toast } from "react-toastify";
import LoaderSpinner from "./Loader";

const VerifyAccount = () => {
    let tokenValue = window.location.search.split("?verificationToken=")[1];
    const {isLoggedIn} = useSelector((state) => state.auth);
    const [loader, setLoader] = React.useState(true);
    const [message, setMessage] = React.useState("Verifying your account, please wait...");
    const [verificationStatus, setVerificationStatus] = React.useState(null);

    useEffect(() => {
        if (isLoggedIn) {
            window.location.href = "/";
        } else {
            handleAccountVerification();
        }
    }, [isLoggedIn]);

    const isAlreadyVerifiedResponse = (res) => {
        const entity = (res?.data?.Entity || '').toString().trim().toLowerCase();
        const appStatusDesc = (res?.data?.Message?.AppStatusDescription || '').toString().trim().toLowerCase();
        // Matches phrasings like "already verified" and "already been verified"
        const alreadyVerifiedRegex = /already(\s+\w+)?\s+verified/;
        return alreadyVerifiedRegex.test(entity) || alreadyVerifiedRegex.test(appStatusDesc);
    };

    const handleAccountVerification = async() => {
        setLoader(true);
        let res = await verifySignupToken({ verificationToken: tokenValue });
        if (res?.data?.Status === 200) {
            setMessage("Your account has been successfully verified.");
            toast.success('Your account has been successfully verified.');
            setVerificationStatus(true);
        } else if (isAlreadyVerifiedResponse(res)) {
            setMessage("Your email is already verified. Please log in using your password.");
            setVerificationStatus('alreadyVerified');
        } else {
            setMessage("Verification failed. The token may be invalid or expired.");
            toast.error(res?.data?.Entity);
            setVerificationStatus(false);
        }
        setLoader(false);
    };

    const renderVerificationIcon = () => {
        return (
            <>
                <p>Your email has been successfully verified.</p>
                <p>
                    Thank you for confirming your email address! To proceed further with{" "}
                    <b>{findIsHostShipAi() ? "ShipVisionAI" : "3PLVision"}</b>, you are required to upload the necessary documents for verification.
                </p>

                <p>
                    Once your documents are submitted, our team will review them. You will be notified after your account has been approved.
                </p>
                <p>
                    Until then, access to platform services will remain limited.
                </p>
                <p>
                    If you need any assistance, our support team is always here to help.
                </p>

                <p>
                    Thank you for choosing{" "}
                    <b>{findIsHostShipAi() ? "ShipVisionAI" : "3PLVision"}</b>! 🚀
                </p>
            </>
        )
    }

    const renderVerficationFailed = () => {
        return (
            <>
                <p>We're sorry — we couldn't verify your email address.</p>
                <p>This may have happened because the verification link has expired or is invalid.</p>
                <p>Please try verifying again using the latest email we sent you. If you continue to experience issues, feel free to contact our support team for assistance.</p>
                <p>We look forward to welcoming you to <b>{renderTextBasedOnDomain()}</b> soon!</p>
            </>
        )
    }

    const renderAlreadyVerified = () => {
        return (
                <p>Your email is already verified. Please log in using your password.</p>
        )
    }

    const renderTextBasedOnDomain = () => {
        return findIsHostShipAi() ? 'ShipVisionAI' : '3PLVision'
    }

    const renderVerificationContent = () => {
        if (verificationStatus === true) return renderVerificationIcon();
        if (verificationStatus === 'alreadyVerified') return renderAlreadyVerified();
        return renderVerficationFailed();
    }

    const showGoToLoginButton = verificationStatus === true || verificationStatus === 'alreadyVerified';

    return (
        <>
            {!isLoggedIn ? (
                <div className="cus-login-pg login-form-center">
                    <div className="cus-login-pg-sec" style={{minHeight: '450px'}}>
                        <div className="cus-login-pg-left-sec">
                            <img alt="" className="cus-main-logo-img" src={renderTextBasedOnDomain()} />
                        </div>
                        <div className="cus-login-pg-right-sec">
                            <div className="cus-welcome-txt">
                                Welcome to <span>{renderTextBasedOnDomain()}</span>
                            </div>
                            <div className="cus-login-form mt-4">
                                {loader && <LoaderSpinner size="md" />}
                                <p className="verification-message">{loader ? message : ""}</p>
                            </div>
                            {verificationStatus !== null && (
                                <div className="verifyText1 mt-4">
                                    {renderVerificationContent()}
                                    <div className="">
                                        { showGoToLoginButton && (
                                            <button className="btn cus-seconday-bg-btn" onClick={() => window.location.href = "/"}>Go to Login</button> 
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            ) : (
                <></>
            )}
        </>
    );
};

export default VerifyAccount;
